import styled, { css } from 'styled-components';

import exagon from 'assets/splash_exagon.svg';
import repfy_logo_white from 'assets/repfy_logo_white.svg';

const Animations = css`
  @keyframes rightTopAnimation {
    0% {
      transform: translate(90px, -95px) rotate(223deg);
    }
    100% {
      transform: translate(54px, -25px) rotate(223deg) scale(1.3);
    }
  }

  @keyframes rightBottomAnimation {
    0% {
      transform: translate(-90px, 85px) rotate(2deg);
    }
    100% {
      transform: translate(20px, 205px) rotate(24deg) scale(1.4);
    }
  }

  @keyframes leftTopAnimation {
    0% {
      transform: translate(-130px, -105px) rotate(37deg);
    }
    100% {
      transform: translate(-130px, -65px) rotate(46deg) scale(1.3);
    }
  }

  @keyframes leftBottomAnimation {
    0% {
      transform: translate(-80px, 115px) rotate(234deg);
    }
    100% {
      transform: translate(-35px, 145px) rotate(238deg);
    }
  }

  @keyframes logoAnimation {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  width: 100vw;
  height: 100vh;

  overflow: hidden;

  background: linear-gradient(to bottom, #0078d7 10%, #b3e5f3 130%);

  ${Animations}
  animation: entering .5s ease-in;
`;

const Exagon = styled.div`
  position: absolute;

  height: 230px;
  width: 230px;

  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${exagon});

  @media (min-width: 580px) {
    height: 330px;
    width: 330px;
  }
`;

export const RightTop = styled(Exagon)`
  top: 0;
  right: 0;
  transform: translate(90px, -95px) rotate(223deg);

  animation: rightTopAnimation 2s ease-in-out forwards;
`;

export const RightBottom = styled(Exagon)`
  bottom: 0;
  right: 0;
  transform: translate(-90px, 85px) rotate(2deg);
  animation: rightBottomAnimation 2s ease-in-out forwards;
`;

export const LeftTop = styled(Exagon)`
  top: 0;
  left: 0;
  transform: translate(-130px, -105px) rotate(37deg);
  animation: leftTopAnimation 2s ease-in-out forwards;
`;

export const LeftCenter = styled(Exagon)`
  top: 50%;
  left: 0;
  transform: translate(-260px, -145px) rotate(111deg);
`;

export const LeftBottom = styled(Exagon)`
  bottom: 50px;
  left: -50px;

  transform: translate(-80px, 115px) rotate(234deg);
  animation: leftBottomAnimation 2s ease-in-out forwards;

  @media (min-width: 580px) {
    bottom: 0;
    left: 0;
  }
`;

export const LogoWrapper = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 15px;

  h1 {
    font-size: 24px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 3.5px;
  }

  animation: logoAnimation 2s ease-in forwards;
`;

export const RepfyLogo = styled.div`
  width: 235px;
  height: 50px;
  transform: translateX(10px);

  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${repfy_logo_white});
`;
